// AutoGenerated
import { HesapKayitYorumRequestModel } from "../requestModels/HesapKayitYorumRequestModel"
import { IcerikEklemeRequestModel } from "../requestModels/IcerikEklemeRequestModel"

export class HesapKayitYorumlaRequestModel {
    constructor(
        model: HesapKayitYorumRequestModel,
        icerikList: IcerikEklemeRequestModel[],
    ) {
        this.model = model;
        this.icerikList = icerikList;
    }

    model: HesapKayitYorumRequestModel;
    icerikList: IcerikEklemeRequestModel[];
}